import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AnimatePresence, motion } from "motion/react";
import defaultPlaceholderImage from "../../assets/placeholder-product-image.svg";
import { useInView } from "react-intersection-observer";
import useIsMounted from "../../hooks/useIsMounted";

function ImageLoader({
  className,
  containerClassName,
  label,
  imageUrl,
  placeholderImageUrl,
  children
}) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0
  });
  const isMounted = useIsMounted();

  useEffect(() => {
    const loader = document.createElement("img");
    if (inView && !loader.src) {
      loader.onload = () => {
        if (isMounted()) setImageLoaded(true);
      };
      loader.src = imageUrl;
    }
    return () => {
      loader.onload = null;
    };
  }, [inView, imageUrl, isMounted]);

  const backgroundImage = placeholderImageUrl || defaultPlaceholderImage;

  return (
    <div className={containerClassName} ref={ref}>
      <AnimatePresence initial={false}>
        {!imageLoaded && (
          <motion.div
            className={className}
            role="img"
            aria-label={label}
            style={{
              opacity: 1,
              backgroundImage: `url('${backgroundImage}')`
            }}
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              type: "spring",
              damping: 10,
              stiffness: 100
            }}
          />
        )}
      </AnimatePresence>
      {children}
    </div>
  );
}

ImageLoader.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  placeholderImageUrl: PropTypes.string,
  imageUrl: PropTypes.string.isRequired
};

export default ImageLoader;
